// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__dMSz1","bigColWidth":"Table_bigColWidth__2A_Ua","biggerColWidth":"Table_biggerColWidth__3ffJu","row":"Table_row__2S2Yj","col":"Table_col__1aQad"};